import Cookies from "js-cookie";

var perToEngMap = {
  "۰": "0",
  "٠": "0",
  "۱": "1",
  "١": "1",
  "۲": "2",
  "٢": "2",
  "۳": "3",
  "٣": "3",
  "۴": "4",
  "٤": "4",
  "۵": "5",
  "٥": "5",
  "۶": "6",
  "٦": "6",
  "۷": "7",
  "٧": "7",
  "۸": "8",
  "٨": "8",
  "۹": "9",
  "٩": "9",
};
export function perToEngDigits(str) {
  try {
    return str
      .toString()
      .replace(/[\u0660-\u0669\u06F0-\u06F9]/g, (match) => perToEngMap[match]);
  } catch (e) {
    return str;
  }
}

var engToPerMap = "۰۱۲۳۴۵۶۷۸۹";
export function engToPerDigits(str) {
  try {
    return str
      .toString()
      .replace(/[0-9]/g, (match) => engToPerMap[parseInt(match)]);
  } catch (e) {
    return str;
  }
}

export function showPassword(element) {
  element.classList.toggle("fa-eye-slash");
  element.classList.toggle("fa-eye");
  let t = document.getElementById(element.getAttribute("data-bs-target"));
  t.type = t.type === "password" ? "text" : "password";
}
export function palceholderOnClick(element) {
  document.querySelector(`#${element.getAttribute("data-bs-target")}`).focus();
}
export function placeholderHandler(element, action) {
  var placeholder = document.querySelector(`#${element.id} ~ .placeholder`);
  if (action === "focus") {
    placeholder.classList.add("focus");
  } else if (action === "blur") {
    if (element.value) {
      placeholder.classList.add("focus");
    } else {
      placeholder.classList.remove("focus");
    }
  }
}

export function _sidebar(action) {
  let classListAction;
  switch (action) {
    case "open":
      classListAction = "remove";
      Array.from(
        document.querySelectorAll('[data-bs-toggle="tooltip"].sidebar-item-icon')
      ).forEach((element) => {
        const tooltip = bootstrap.Tooltip.getOrCreateInstance(element);
        tooltip.disable();
      });
      // $('[data-bs-toggle="tooltip"].sidebar-item-icon').tooltip("disable");
      window.localStorage.setItem("sidebar", "open");
      break;
    case "close":
      classListAction = "add";
      Array.from(
        document.querySelectorAll('[data-bs-toggle="tooltip"].sidebar-item-icon')
      ).forEach((element) => {
        const tooltip = bootstrap.Tooltip.getOrCreateInstance(element);
        tooltip.enable();
      });
      // $('[data-bs-toggle="tooltip"].sidebar-item-icon').tooltip("enable");
      window.localStorage.setItem("sidebar", "close");
      break;
    case "toggle":
      classListAction = "toggle";
      if (["close", "open"].includes(window.localStorage.getItem("sidebar"))) {
        ({
          close: () => _sidebar("open"),
          open: () => _sidebar("close"),
        }[window.localStorage.getItem("sidebar")]());
      } else if (
        document.querySelector(".sidebar").classList.contains("close-sidebar")
      ) {
        _sidebar("open");
      } else {
        _sidebar("close");
      }
      return;
    default:
      return;
  }

  document
    .querySelector(".sidebar")
    .classList[classListAction]("close-sidebar");
  document
    .querySelector(".profile-content-container")
    .classList[classListAction]("close-sidebar");
  document.querySelector(".navbar").classList[classListAction]("close-sidebar");
  document
    .querySelector(".dim-layer")
    .classList[classListAction]("close-sidebar");
}

export function cleanUrl(url, type) {
  url = url
    .replace("https://", "")
    .replace("http://", "")
    .replace("www.", "");
  switch (type) {
    case "website":
      return url.split(/[/?#]/)[0];

    case "telegram":
      return url
        .replace("telegram.me/", "")
        .replace("t.me/", "")
        .replace("@", "");

    case "instagram":
      return url.replace("instagram.com/", "");

    case "android_app":
      return url
        .replace("play.google.com/store/apps/details?id=", "")
        .replace("cafebazaar.ir/app/", "")
        .split(/[/=?#]/)[0];

    case "ios_app":
      return url.split("app/")[1];

    case "title":
      return url;

    default:
      console.log("invalid url type");
      break;
  }
  return;
}

export function changeLang(lang) {
  try {
    Cookies.set("LANG", { fa: "en", en: "fa" }[lang] || "fa");
  } catch (error) {
    console.log("error");
  }
  window.location.reload(true);
}

export function getParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  const urlParam = urlParams.get(param);

  return urlParam;
}
